// extracted by mini-css-extract-plugin
module.exports = {"col2":"skireport_col2__1NAfa","seoText":"skireport_seoText__34xZ7"};